import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getGedPorIdTipo(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("ged/access/obterPorIdTipo", {ID_TIPO: dados.tipo, ID_CODIGO: dados.idTipo}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getGedPorEmitente(context, emitente) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("ged/access/obterPorEmitente", {ID_EMITENTE: emitente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};